import { createSelector } from '@reduxjs/toolkit'

import type { TCompanyGroupDto } from '@homepal/api-contract'

import { ApplicationState } from 'redux/Stores/types'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

// select all company groups
export const selectAll = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CompanyGroupStore.data,
    (state: ApplicationState) => state.CompanyGroupStore.fetched
  ],
  (data, fetched): [TCompanyGroupDto[], boolean] => [
    Object.values(data).sort((a, b) => sortAlphabeticalAsc(a.name, b.name)),
    !fetched
  ]
)

// select company groups keyed by id
export const selectCompanyGroupsData = createSelector(
  [(state: ApplicationState) => state.CompanyGroupStore.data],
  (data) => data
)

export const selectCompanyGroupsFetched = createSelector(
  [(state: ApplicationState) => state.CompanyGroupStore.fetched],
  (fetched) => fetched
)

export const selectCompanyStructureSyncStatus = createSelector(
  [(state: ApplicationState) => state.CompanyGroupStore.syncStatus],
  (syncStatus) => syncStatus
)
